// extracted by mini-css-extract-plugin
module.exports = {"tabsPrimaryLine":"antd-pro-ui-tabs-index-tabsPrimaryLine","tabsPrimaryCard":"antd-pro-ui-tabs-index-tabsPrimaryCard","topPosition":"antd-pro-ui-tabs-index-topPosition"};